// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"VideoList_placeholder__2XsMt","group":"VideoList_group__1fm9_","cardGrid":"VideoList_cardGrid__1VYRV"};